import { NgModule } from '@angular/core';
import { DatePipe } from '@angular/common';
import { TimeFilterPipe } from '@pipes/time-filter/time-filter';
import { SafeHtmlPipe } from '@pipes/safe-html/safe-html';
import { ProfilePriceFilterPipe } from '@pipes/profile-price-filter/profile-price-filter';
import { OrderByPipe } from '@pipes/order-by/order-by';
import { OrderByDatePipe } from '@pipes/order-by-date/order-by-date';
import { DatepickerFilterPipe } from '@pipes/datepicker-filter/datepicker-filter';
import { BoldPipeFilter } from '@pipes/bold/boldPipe';
import { SnDatePickerConfigPipe } from '@pipes/sn-date-picker-config/sn-date-picker.config';
import { CutStringFilterPipe } from '@pipes/cut-string/cut-string';
import { OrderByNamePipe } from '@pipes/order-by/order-by-name';
import { DndAutoScroll } from '@pipes/dnd-autoscroll/dnd-autoscroll';

@NgModule({
	declarations: [
		TimeFilterPipe,
		SafeHtmlPipe,
		ProfilePriceFilterPipe,
		OrderByPipe,
		OrderByDatePipe,
		DatepickerFilterPipe,
		SnDatePickerConfigPipe,
		CutStringFilterPipe,
		BoldPipeFilter,
		OrderByNamePipe,
		DndAutoScroll
	],
	providers: [
		DatePipe,
		ProfilePriceFilterPipe,
		OrderByPipe,
		OrderByDatePipe,
		DatepickerFilterPipe,
		CutStringFilterPipe,
		SnDatePickerConfigPipe,
		BoldPipeFilter,
		OrderByNamePipe,
		DndAutoScroll
	],
	exports: [
		TimeFilterPipe,
		SafeHtmlPipe,
		ProfilePriceFilterPipe,
		OrderByPipe,
		OrderByDatePipe,
		DatepickerFilterPipe,
		CutStringFilterPipe,
		SnDatePickerConfigPipe,
		BoldPipeFilter,
		OrderByNamePipe,
		DndAutoScroll
	]
})
export class PipesModule {}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=nfw9yna8xro!./shared/pipes/pipes.module.ts